import { z } from "zod";

export const collectionJobSchema = z.object({
  id: z.number().int(),
  status: z.number().int(),
  statusDescription: z.string(),
  triggeredBy: z.string().nullable().optional(),
  queryDescription: z.string().nullable().optional(),
  createdDate: z.string(),
  startedAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
  totalProfiles: z.number().int(),
  processedProfiles: z.number().int(),
  classifiedProfiles: z.number().int().default(0),
  analyzedProfiles: z.number().int().default(0),
  skipAnalysis: z.boolean().default(false),
  lastActivityAt: z.string().nullable().optional(),
  errorMessage: z.string().nullable().optional(),
  remainingCollectCredits: z.number().int().nullable().optional(),
  remainingSearchCredits: z.number().int().nullable().optional(),
});

export const searchQueryFiltersSchema = z.object({
  companyLinkedInUrl: z.string().optional(),
  companyName: z.string().optional(),
  titleKeywords: z.array(z.string()).optional(),
  descriptionKeywords: z.array(z.string()).optional(),
  descriptionKeywordsMatchAll: z.boolean().optional(),
  department: z.string().optional(),
  managementLevel: z.string().optional(),
  activeExperienceOnly: z.boolean().optional(),
  locationCountry: z.string().optional(),
  locationFull: z.string().optional(),
  createdAfter: z.string().optional(),
});

export const createCollectionJobRequestSchema = z.object({
  filters: searchQueryFiltersSchema,
});

export const previewSearchRequestSchema = z.object({
  filters: searchQueryFiltersSchema,
  itemsPerPage: z.number().int().optional(),
});

export const previewProfileSchema = z.object({
  id: z.number(),
  fullName: z.string().nullable().optional(),
  headline: z.string().nullable().optional(),
  activeExperienceTitle: z.string().nullable().optional(),
  activeExperienceDepartment: z.string().nullable().optional(),
  activeExperienceManagementLevel: z.string().nullable().optional(),
  companyName: z.string().nullable().optional(),
  companyIndustry: z.string().nullable().optional(),
  locationFull: z.string().nullable().optional(),
  locationCountry: z.string().nullable().optional(),
  professionalNetworkUrl: z.string().nullable().optional(),
});

export const previewSearchResponseSchema = z.object({
  totalCount: z.number().int(),
  remainingCredits: z.number().int().nullable().optional(),
  profiles: z.array(previewProfileSchema),
});
